import { Component, OnInit } from '@angular/core';
import { RefundFailModalComponent } from '@lib/shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({ standalone: false, selector: 'app-refund-fail-modal', templateUrl: './refund-fail.component.html' })
export class CustomRefundFailModalComponent extends RefundFailModalComponent implements OnInit {
  constructor(protected bsModalRef: BsModalRef) {
    super(bsModalRef);
  }
}
